import { useState, useRef } from 'react';
import { FaCheck, FaRegCopy, FaTimes } from 'react-icons/fa';

export const useCopyToClipboard = ({ text, timeout = 3000 }) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const tout = useRef();
    const copyText = async () => {
        tout.current && clearTimeout(tout.current);
        try {
            if (!text) throw new Error('No text to copy');
            await navigator.clipboard.writeText(text);
            setIsSuccess(true);
            setIsError(false);
            tout.current = setTimeout(() => {
                setIsSuccess(false);
            }, timeout);
        } catch (error) {
            console.error(error);
            tout.current && clearTimeout(tout.current);
            setIsError(true);
            setIsSuccess(false);
        }
    };
    return [copyText, { isSuccess, isError }];
};

const CopyToClipboard = ({ text = '' }) => {
    const [copyText, { isSuccess, isError }] = useCopyToClipboard({ text });
    return (
        <button className="button button-anchor button-small" type="button" disabled={isSuccess} onClick={copyText}>
            {!isSuccess && !isError && <FaRegCopy />}
            {isSuccess && !isError && <FaCheck className="text-success" />}
            {!isSuccess && isError && (
                <>
                    <FaTimes /> Error
                </>
            )}
        </button>
    );
};

export default CopyToClipboard;
